const updateMembers = (state, { payload }) => {
	state.members = payload;
};

export default updateMembers;
